import { GenericService } from './generic.service';
import { Anatomy } from '@/models';

export class AnatomyService extends GenericService<Anatomy> {
  constructor() {
    super('v1/anatomies');
  }
}
